var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Add profiles")]),_vm._v(" "),_c('p',[_vm._v("There are "+_vm._s(_vm.userData.length)+" users to add")]),_vm._v(" "),_c('button',{attrs:{"type":"button","name":"button"},on:{"click":function($event){return _vm.addUsers()}}},[_vm._v("Add users")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5aee196a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/routes/CreateProfiles.vue
// module id = null
// module chunks = 